import FakeUserBio from './FakeUserBio';

export default FakeUserBio;
